import axios from '@axios'

const PREFIX = 'dashboards-cobrancas'

export default {
  getTotalDocumentos(datas) {
    return axios.post(`${PREFIX}/total-documentos`, datas)
  },

  getDadosIniciais() {
    return axios.get(`${PREFIX}/dados-iniciais`)
  },

  getDocumentosEquipe(datas) {
    return axios.post(`${PREFIX}/equipes/documentos`, datas)
  },

  getStatusEquipes(datas) {
    return axios.post(`${PREFIX}/equipes/status`, datas)
  },

  getEmpresasAtivasInativas() {
    return axios.get(`${PREFIX}/empresas`)
  },

  getComESemConfiguracaoCobranca() {
    return axios.get(`${PREFIX}/configuracao-cobranca`)
  },

  getEquipesConfiguracaoCobranca() {
    return axios.get(`${PREFIX}/equipes/configuracao-cobranca`)
  },

  gerarPlanilhaDocumentosEquipes(campos) {
    return axios.post(`${PREFIX}/equipes/documentos/gerar-planilha`, campos)
  },

  gerarPlanilhaEmpresas(campos) {
    return axios.post(`${PREFIX}/empresas/gerar-planilha`, campos)
  },

  gerarPlanilhaConfigurada(campos) {
    return axios.post(`${PREFIX}/configuracao-cobranca/configuradas/gerar-planilha`, campos)
  },

  gerarPlanilhaNaoConfigurada(campos) {
    return axios.post(`${PREFIX}/configuracao-cobranca/nao-configuradas/gerar-planilha`, campos)
  },

  deleteUpload(nomeArquivo) {
    return axios.delete(`${PREFIX}/delete-upload?arquivo=${nomeArquivo}`)
  },
}
